import styled, { css } from 'styled-components';
import { ELLIPSIS, ListItem, getSpacingToken, getTextTokenPreset, getToken } from '@optimus-web/core';

interface ThreadContainerProps {
    isActive: boolean;
}

export const ThreadContainer = styled(ListItem)<ThreadContainerProps>`
    padding: ${getSpacingToken('300')}px ${getSpacingToken('200')}px;
    border-bottom: solid 1px ${getToken('borderDisabled')};
    ${(props) =>
        props.isActive &&
        css`
            background-color: ${getToken('backgroundDisabled')};
        `}
`;

interface Unread {
    unread: boolean;
}

export const ThreadAuthor = styled.div<Unread>`
    ${(props) => getTextTokenPreset(props.unread ? 'bodyLargeStrong' : 'bodyLarge')}
    ${ELLIPSIS}
`;

export const ThreadSubject = styled.span<Unread>`
    ${({ unread }) =>
        unread &&
        css`
            color: ${getToken('textStaticPrimary')};
        `}
`;
